<template>
  <FormSelectAssuranceInput
    :justify-end="justifyEnd"
    :assurance-level="assuranceLevel"
    :init-form="initForm"
    @onSubmit="handleSubmit"
    @clearContent="clearContent"
  />
</template>

<script>
import { getAssurances } from "@/store/helper"
import { VW_SET_ASSURANCE_QUERY } from "@/store/actions/topic.type.js"
import FormSelectAssuranceInput from "./FormSelectAssuranceInput"
import { CLEAR_ASSURANCE } from "@/store/action.type"

export default {
  name: "FormSelectAssurance",
  components: {
    FormSelectAssuranceInput,
  },
  props: {
    justifyEnd: {
      type: Boolean,
      default: false,
    },
    assuranceLevel: {
      type: Number | String,
      default: "",
    },
    initForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        assuranceLevelId: "",
        yearId: "",
        facultyId: "",
        majorId: "",
      },
    }
  },
  methods: {
    clearContent() {
      this.$emit("update:allowCreate", false)
      this.$store.dispatch(CLEAR_ASSURANCE)
    },
    async handleSubmit(formData) {
      this.$emit("update:allowCreate", true)
      this.$store.dispatch(VW_SET_ASSURANCE_QUERY, formData)

      const { assuranceLevelId, yearId, facultyId, majorId } = formData
      getAssurances(assuranceLevelId, yearId, facultyId, majorId)
    },
  },
}
</script>